import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { v4 as uuid } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';

import { Dropdown } from 'react-bootstrap-5';

import MenuItems from 'components/dropdown/menu_items';

import './styles.scss';

// eslint-disable-next-line no-unused-vars
const ToggleWrapper = React.forwardRef(({ children }, ref) => <>{children}</>);

export const parentItemIdPrefix = 'dropdown-parent-item';
export const nestedMenuIdPrefix = 'dropdown-menu';

export default function DropdownParentItem({ children, icon, label, nestedMenuClassName, open, ...props }) {
  // react-bootstrap Dropdown components do not forward refs correctly, so set static IDs for lookup
  const parentItemId = useMemo(() => `${parentItemIdPrefix}-${uuid()}`, []);
  const nestedMenuId = useMemo(() => `${nestedMenuIdPrefix}-${uuid()}`, []);

  const [nestedMenuStyle, setNestedMenuStyle] = useState({});

  React.useEffect(() => {
    const style = { ...nestedMenuStyle, visibility: 'hidden' };

    if (open) {
      style.visibility = 'visible';

      const {
        right: parentRight,
        top: parentTop,
        width: parentWidth,
        height: parentHeight,
      } = document.querySelector(`#${parentItemId}`).getBoundingClientRect();

      const {
        width: nestedMenuWidth,
        height: nestedMenuHeight,
      } = document.querySelector(`#${nestedMenuId}`).getBoundingClientRect();

      if (parentRight + nestedMenuWidth < window.innerWidth) {
        style.left = `${parentWidth - 1}px`;
      } else {
        style.left = `-${nestedMenuWidth}px`;
      }

      if (parentTop + nestedMenuHeight < window.innerHeight) {
        style.top = '-8px';
      } else {
        style.top = `-${nestedMenuHeight - parentHeight - 4}px`;
      }
    }

    setNestedMenuStyle(style);
  }, [open]);

  return (
    <Dropdown.Item
      className="dropdown-parent-item"
      id={parentItemId}
      style={{ position: 'relative' }}
      {...props}
      as="div"
    >
      <Dropdown className="d-flex w-100 align-items-center">
        <Dropdown.Toggle as={ToggleWrapper}>
          {icon && <FontAwesomeIcon className="me-2" icon={icon} />}
          {icon ? ` ${label}` : label}
          <FontAwesomeIcon className="ms-auto" icon={faAngleRight} />
        </Dropdown.Toggle>

        <Dropdown.Menu
          align="start"
          className={classNames('dropdown-nested-menu', nestedMenuClassName)}
          id={nestedMenuId}
          renderOnMount
          style={{ ...nestedMenuStyle, zIndex: 1100 }}
        >
          <MenuItems>
            {children}
          </MenuItems>
        </Dropdown.Menu>
      </Dropdown>
    </Dropdown.Item>
  );
}

DropdownParentItem.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.object,
  label: PropTypes.string.isRequired,
  nestedMenuClassName: PropTypes.string,
  open: PropTypes.bool,
};
